// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalZenFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M38.989 87.284c-19.092 0-30.489-5.17-30.489-13.828 0-11.025 18.495-12.153 27.733-12.268-7.209-1.324-12.052-3.845-12.133-8.62-.031-1.847.715-3.557 2.216-5.084 3.177-3.232 9.569-5.319 16.727-6.543h-.127c-5.081 0-20.542-.002-20.542-9.698 0-6.2 6.338-8.008 13.806-8.508-3.229-1.273-5.367-3.695-5.367-6.534 0-4.196 4.671-7.484 10.635-7.485 5.963 0 10.634 3.289 10.634 7.486 0 2.783-2.055 5.166-5.179 6.456 10.066.521 24.212 3.06 24.212 10.197 0 3.456-2.989 5.497-8.199 6.664 7.928.077 24.584.953 24.584 10.877 0 3.673-2.594 12.218-26.617 12.218-1.765 0-3.525-.005-5.267-.026 13.398 2.206 25.628 6.898 25.628 13.342 0 4.182-4.695 7.154-14.356 9.088-7.3 1.462-17.209 2.266-27.899 2.266"
			fillRule="evenodd"
		/>
	</svg>
);
export default GoalZenFilled;
